import ajax from "@/libs/Ajax";

let NAME_SPACE = "/aseapi/console/rsrcmgr/rcmgr";
export default {
  listBizChain(params) {
    return ajax.get(`${NAME_SPACE}/listBizChain`, {params});
  },
  selectBizChain(params) {
    return ajax.get(`${NAME_SPACE}/selectBizChain`, {params});
  },
  listBizCom(params) {
    return ajax.get(`${NAME_SPACE}/listBizCom`, {params});
  },
  saveBizChain(data) {
    return ajax.post(`${NAME_SPACE}/saveBizChain`, data);
  },
  saveBizCom(data) {
    return ajax.post(`${NAME_SPACE}/saveBizCom`, data);
  },
  getBizChain(params) {
    return ajax.get(`${NAME_SPACE}/getBizChain`, {params});
  },
  getBizCom(params) {
    return ajax.get(`${NAME_SPACE}/getBizCom`, {params});
  },
  deleteBizChain(params) {
    return ajax.delete(`${NAME_SPACE}/deleteBizChain`, {params});
  },
  deleteBizCom(params) {
    return ajax.delete(`${NAME_SPACE}/deleteBizCom`, {params});
  },
  getDxpComs(){
    return ajax.get(`${NAME_SPACE}/getDxpComs`);
  }
};
